import React, { createContext, useState } from "react";
import orderObject from "../constants/data/orderCreation";
// import { path } from "./../constants/apiPath";
import useForm from "../common/hooks/useForm";
import useAutoComplete from "../common/hooks/useAutoComplete";
import useExcel from "../common/hooks/useExcel";
// import axios from "axios";
// import instance from "../common/api/interceptor";

const lineObject = {
  "Line No.": "",
  "Item No.": "",
  Description: "",
  "Inner Packs": "",
  "Inner Package Type": "",
  "Outer pack": "",
  "Outer Package Type": "",
  "Qty. Ordered": "",
  "Qty. Received": "",
  "Qty. Remaining": "",
  "Unit of Qty.": "",
  "Item Price": "",
  "Total Price": "",
  "Req. in Store Date": "",
  "INCO term": "",
  "Additional Terms": "",
  "Confirm Number": "",
  "Confirm Date": "",
};
const StoreContext = createContext();

const OmsStoreProvider = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const [placedOrders, setPlacedOrders] = useState({});
  const [approvedOrders, setApprovedOrders] = useState({});
  const [loadedOrders, setLoadedOrders] = useState({});
  const [rejectedOrders, setRejectedOrders] = useState({});
  const [backDropOpen, setBackDropOpen] = useState(false);
  const [logData, setLogData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [userList, setUserList] = useState([]);

  const [editMode, setEditMode] = useState(false);

  const [supplierName, setSupplierName] = useState([]);
  const [reciverName, setReciverName] = useState([]);
  const [orderJSON, setOrderJSON] = useState({
    ...orderObject,
  });
  const [dashBoardBody, setDashBoardBody] = useState({
    page: 0,
    dataLength: 0,
    hasMore: true,
    pageSize: 10,
  });

  const [editOrderJSON, setEditOrderJSON] = useState({
    OrderLinesCollection: [],
    OrderHeader: {
      OrderContainerCollection: [],
      OrderPlanningContainerRatesCollection: [],
    },
    OrderMilstonesCollection: [],
    OrderPlanningCollection: [],
    OrderDocumentsCollection: [],
    OrderNotesCollection: [],
  });

  const [originPort, setOriginPort] = useState([]);
  const [destinationPort, setDestinationPort] = useState([]);

  const [defaultValue, setDefaultValue] = useState({
    serviceLevel: [],
    transportMode: [],
    containerMode: [],
    supplierName: [],
    reciverName: [],
    originCountry: [],
    currency: [],
    incoTerm: [],
    orderStatus: [],
    supplierAddress: [],
    recieverAddress: [],
    originPort: [],
    destinationPort: [],
    sendingAgent: [],
    recivingAgent: [],
    packType: [],
    weightType: [],
    dimenssionsUnit: [],
    volumeUnit: [],
    containerType: [],
  });

  const orderLine = useExcel([{ ...lineObject }]);

  //order plan
  const sendingAgent = useAutoComplete("", "OrgName");
  const receivingAgent = useAutoComplete("", "OrgName");
  const carrier = useAutoComplete("", "OrgName");
  const masterbillOrderNumber = useForm();
  const cutOffDate = useForm();
  const departureDate = useForm();
  const arrivalDate = useForm();
  const vessel = useForm();
  const voyage = useForm();
  const originUnlocos = useAutoComplete("", "PortName");
  const destinationUnlocos = useAutoComplete("", "PortName");
  const [value, setValue] = React.useState("1");
  const [num, setNum] = useState(1);
  const [item, setItem] = useState([1]);
  const [directions, setDirections] = useState("D");
  const [valueSlider, setValueSlider] = useState(2);
  const [userData, setUserData] = useState({});
  const [docDataList, setDocDataList] = useState([]);

  const [userAccess, setUserAccess] = useState({});
  const [orderUserAccess, setOrderUserAccess] = useState({});
  
  return (
    <StoreContext.Provider
      value={{
        orderUserAccess,
        userAccess,
        setUserAccess,
        originPort,
        setOriginPort,
        destinationPort,
        setDestinationPort,
        editOrderJSON,
        setEditOrderJSON,
        collapsed,
        modalOpen,
        orderJSON,
        userData,
        defaultValue,
        setDefaultValue,
        orderLine,
        masterbillOrderNumber,
        sendingAgent,
        receivingAgent,
        carrier,
        voyage,
        vessel,
        arrivalDate,
        departureDate,
        cutOffDate,
        docDataList,
        value,
        dashboardData,
        rejectedOrders,
        loadedOrders,
        approvedOrders,
        placedOrders,
        logData,
        setValue,
        destinationUnlocos,
        originUnlocos,
        backDropOpen,
        setBackDropOpen,
        valueSlider,
        setValueSlider,
        directions,
        setDirections,
        item,
        setItem,
        userList,
        setUserList,
        dashBoardBody,
        setDashBoardBody,
        reportData,
        setReportData,
        num,
        editMode,
        supplierName,
        setReciverName,
        reciverName,
        setSupplierName,
        setEditMode,
        setNum,
        setOrderJSON,
        setCollapsed,
        setModalOpen,
        setUserData,
        setDocDataList,
        setDashboardData,
        setRejectedOrders,
        setLoadedOrders,
        setApprovedOrders,
        setPlacedOrders,
        setLogData,
        setOrderUserAccess,
      }}
    >
      {props.children}
    </StoreContext.Provider>
  );
};

export { OmsStoreProvider, StoreContext };
